<template>
  <div class="fa-fileFullWrapper">
    <div class="fa-subTitle">Файлын мэдээлэл</div>
    <div class="fa-fileInfoWrapper">
      <div class="fa-fileNameWrapper">
        <span style="height: 16px; margin-right: 8px">
          <FileSimpleIcon />
        </span>
        Файлын нэр:<span class="fa-fileName">{{ fileInfo.fileName }}</span>
      </div>
      <div class="fa-fileActionsWrapper">
        <v-btn class="fa-synthesizeButton" @click="showConfigDialog" v-if="pageInfo.status != 'synthesized'"
          :disabled="pageInfo.status == 'synthesizing'">
          <div v-if="pageInfo.status == 'synthesizing'" class="d-flex align-center">
            {{
                `${this.pageInfo.synthesized}/${this.pageInfo.total} Хөрвүүлж байна`
            }}
          </div>
          <div v-else class="d-flex align-center">
            <MicWhiteIcon style="margin-right: 10px" /> Файлыг яриа руу хувиргах
          </div>
        </v-btn>
        <v-btn v-if="pageInfo.status == 'synthesized'" class="fa-allPlayButton" @click="playAllAudios">
          <PauseOutlineIcon v-if="allPlay" :width="18" :height="18"
            style="margin-right: 10px; color: white !important" />
          <PlayFillIcon v-else style="margin-right: 10px" />
          Бүгдийг тоглуулах
        </v-btn>
        <v-menu v-if="pageInfo.synthesized > 0" bottom left min-width="230px" max-width="230px" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="fa-thingsBtn" style="margin: 0 0 0 10px" v-on="on">
              <DownloadIcon style="margin-right: 10px" />
              Татах
              <ArrowDownIcon style="margin-left: 10px" />
            </v-btn>
          </template>
          <v-list>
            <v-list-item-content class="align-center">
              <a :href="
                'https://reader.chimege.com:9001/v2/group/' +
                fileInfo.fileId +
                '/download?type=archived&token=' +
                getToken
              " class="link" target="_self" :download="fileInfo.fileName"
                style="display: flex; text-decoration: none">
                <v-list-item class="fa-listItem" style="
                    padding-top: 10px !important;
                    padding-bottom: 10px !important;
                  ">
                  <div class="d-flex align-center justify-space-between" style="width: 100%">
                    <div class="d-flex flex-column">
                      <div class="fa-listTitle">Архивлах</div>
                      <div class="fa-listDesc">
                        Хөрвүүлэгдсэн бүх хуудсыг тус бүрийг файл болгон татаж
                        авах
                      </div>
                    </div>
                    <div style="width: 16px; height: 16px; margin-left: 20px">
                      <DownloadIcon color="#767676" />
                    </div>
                  </div>
                </v-list-item>
              </a>
              <a :href="
                'https://reader.chimege.com:9001/v2/group/' +
                fileInfo.fileId +
                '/download?type=merged&token=' +
                getToken
              " class="link" target="_self" :download="fileInfo.fileName"
                style="display: flex; text-decoration: none">
                <v-list-item style="
                    padding-top: 10px !important;
                    padding-bottom: 10px !important;
                  ">
                  <div class="d-flex align-center justify-space-between" style="width: 100%">
                    <div class="d-flex flex-column">
                      <div class="fa-listTitle">Экспортлох</div>
                      <div class="fa-listDesc">
                        Хөрвүүлэгдсэн бүх хуудсыг нэг аудио файл болгон татаж
                        авах
                      </div>
                    </div>
                    <div style="width: 16px; height: 16px; margin-left: 20px">
                      <DownloadIcon color="#767676" />
                    </div>
                  </div>
                </v-list-item>
              </a>
            </v-list-item-content>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div v-if="!infoLoading" class="fa-pageInfoWrapper">
      <div class="fa-textShowWrapper">
        <div class="fa-subTitle">Хуудасны мэдээлэл</div>
        <textarea class="fa-textInput" ref="textInput" placeholder="Энд бичвэрээ оруулна уу..." name="textInput"
          rows="4" cols="50" v-model="pageInfo.text" :readonly="readOnly">
        </textarea>
      </div>
      <div class="fa-settingsWrapper">
        <div class="fa-settingsTitleWrapper">
          <div class="fa-settingsTitle">
            <div style="height: 18px; margin-right: 5px">
              <SettingsIcon />
            </div>
            Тохиргоо
          </div>
          <div class="fa-videoIns" @click="watchVideo">
            <div style="height: 16px; margin-right: 5px">
              <QuizOutlineIcon />
            </div>
            Видео заавар үзэх
          </div>
        </div>
        <div v-if="pageInfo.status_new != 'ready'">
          <div class="fa-toolsWrapper">
            <div>
              <div class="fa-audioTitleStyle">
                Хуудасны дугаар:
                <span class="fa-fileInfoStyle">№{{ page }}</span>
              </div>
              <div v-if="pageInfo.status_new == 'synthesized'" class="fa-audioTitleStyle">
                Хөрвүүлсэн өдөр:
                <span class="fa-fileInfoStyle">{{ getFormatDate }}</span>
              </div>
              <div class="fa-audioTitleStyle">
                Ашигласан тэмдэгтийн тоо:
                <span class="fa-fileInfoStyle">{{ pageInfo.text.length }}</span>
              </div>
              <div class="fa-audioTitleStyle">
                Хоолой:
                <span class="fa-fileInfoStyle">{{
                    pageInfo.voice_id == 2 ? "Эрэгтэй" : "Эмэгтэй"
                }}</span>
              </div>
              <div class="fa-audioTitleStyle">
                Тоглуулах хурд:
                <span class="fa-fileInfoStyle">{{ getSpeedIns }}</span>
              </div>
              <div>
                Хоолойны өнгө:
                <span class="fa-fileInfoStyle">{{ pageInfo.pitch.toString() }}</span>
              </div>
            </div>
            <div v-if="pageInfo.status_new == 'synthesized'">
              <div v-if="readOnly == true" class="fa-synthesizedWrapper">
                <div id="audio">
                  <AudioPlayer :file="
                    `https://reader.chimege.com:9001/${pageInfo.audio_path}`
                  " :autoPlay="autoPlay" :onEnd="onEnd"></AudioPlayer>
                </div>
                <div class="fa-thingsBtnWrapper">
                  <v-btn class="fa-againSynthBtn" @click="editText">
                    <div style="margin-right: 10px">
                      <FixIcon />
                    </div>
                    Дахин хөрвүүлэх
                  </v-btn>
                  <a :href="
                    hostURl +
                    '/v2/download/' +
                    filename +
                    '?token=' +
                    getToken
                  " target="_self" :download="pageInfo.name" style="display: flex; text-decoration: none">
                    <v-btn class="fa-thingsBtn">
                      <div style="margin-right: 10px">
                        <DownloadIcon />
                      </div>
                      Татах
                    </v-btn>
                  </a>
                  <!-- <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="fa-pageRemoveBtn"
                        style="margin-top: 10px"
                        v-bind="attrs"
                        v-on="on"
                        @click="toggleDialog"
                        ><DeleteIcon :width="18" :height="18"
                      /></v-btn>
                    </template>
                    <span>Тухайн хуудсыг устгах</span>
                  </v-tooltip> -->
                </div>
              </div>
              <div v-else>
                <v-btn class="fa-cancelBtn" @click="editText">
                  <div style="height: 24px; margin-right: 10px">
                    <ArrowLeftIcon />
                  </div>
                  Болих
                </v-btn>
                <v-btn class="fa-synthesizeButton" style="margin-top:10px" @click="againSynthesizePage"
                  :loading="loading">
                  <div style="margin-right: 10px">
                    <MicWhiteIcon />
                  </div>
                  Яриа руу хувиргах
                </v-btn>
              </div>
            </div>
            <div v-else class="fa-transcribingShow">
              <div v-if="pageInfo.status_new === 'audio_building'">
                Аудиог бэлтгэж байна...
              </div>
              <div v-else>
                {{ pageInfo.percent }}%
                <span style="margin-left: 10px">Хөрвүүлж байна</span>
              </div>
            </div>
          </div>
          <!-- <v-btn
              v-if="pageInfo.percent == 100"
              class="fa-synthesizeButton"
              @click="synthesizePage"
              :loading="loading"
            >
              <div style="margin-right: 10px">
                <MicWhiteIcon />
              </div>
              Яриа руу хувиргах
            </v-btn> -->
        </div>
        <div v-else class="fa-toolsWrapper">
          <div>
            <div class="fa-checkBoxTitle">Хоолой сонгох</div>
            <v-radio-group v-model="voiceId" hide-details>
              <div class="fa-checkboxWrapper" v-for="(n, index) in voice" :key="index">
                <v-radio class="fa-checkboxLabel" color="#787ff7" :label="`${n.people}`" :value="n.value"></v-radio>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="fa-playButton" @click="testVoice(n.value)" v-on="on" v-bind="attrs">
                      <PlayButtonIcon />
                    </div>
                  </template>
                  <span>Тоглуулах</span>
                </v-tooltip>
              </div>
            </v-radio-group>
            <div class="fa-soundSpeed">Тоглуулах хурд сонгох</div>
            <div class="fa-speedSelectWrapper">
              <v-select offset-y :items="voiceSpeed" v-model="speed" item-text="title" item-value="value"
                item-color="gray" dense outlined></v-select>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="fa-playSpeedButton" @click="testVoice(3)" v-on="on" v-bind="attrs">
                    <PlayButtonIcon />
                  </div>
                </template>
                <span>Тоглуулах</span>
              </v-tooltip>
            </div>
          </div>
          <div class="fa-toolsBtnWrapper">
            <v-btn class="fa-synthesizeButton" @click="synthesizePage" :loading="loading">
              <div style="margin-right: 10px">
                <MicWhiteIcon />
              </div>
              Хуудсыг яриа руу хувиргах
            </v-btn>
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="fa-pageRemoveBtn"
                  v-bind="attrs"
                  v-on="on"
                  @click="toggleDialog"
                  ><DeleteIcon :width="18" :height="18"
                /></v-btn>
              </template>
              <span>Тухайн хуудсыг устгах</span>
            </v-tooltip> -->
          </div>
        </div>
      </div>
    </div>
    <div v-else class="fa-infoLoadingWrapper">
      <v-progress-circular :size="40" :width="3" color="#787ff7" indeterminate></v-progress-circular>
    </div>
    <div class="fa-paginationWrapper">
      <v-pagination v-model="page" :length="pages.length" circle :total-visible="6" prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right" color="#787ff7" @input="nextPage"></v-pagination>
      <div class="fa-jumpPageWrapper">
        <div class="fa-jumpPageTitle">Хуудас руу очих</div>
        <div class="fa-inputNumber">
          <input type="number" :placeholder="page" :max="pageInfo.total" min="1" v-model="jump_page" />
        </div>
        <v-btn class="fa-jumpBtn" @click="jumpPage">Очих
          <ArrowLeftIcon style=" -ms-transform: rotate(180deg);transform: rotate(180deg);" />
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="removeDialog" persistent max-width="380">
      <v-card class="fa-dialogWrapper">
        <div class="fa-dialogRemoveTitleWrapper">
          <DeleteIcon />
          <div class="fa-dialogRemoveTitle">Хуудас устгах</div>
        </div>
        <div class="fa-dialogRemoveQuestion">
          Та хуудас утсгахдаа итгэлтэй байна уу?
        </div>
        <div class="fa-dialogActionWrapper">
          <v-btn color="darken-1" class="fa-closeBtn" text @click="toggleDialog">хаах</v-btn>
          <v-btn class="fa-removeBtn" text @click="removePage" :loading="dialogLoading">Тийм</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="configDialog" persistent max-width="500">
      <v-card>
        <div class="fa-dialogConfigWrapper">
          <div>
            <div class="fa-settingsTitle">
              <div style="height: 18px; margin-right: 5px">
                <SettingsIcon />
              </div>
              Тохиргоо
            </div>
            <div class="fa-dialogConfigWarnWrapper">
              <InfoIcon />
              <div class="fa-dialogConfigWarn">
                Уг тохиргоогоор бүх хуудас хөрвүүлэгдэх болохыг анхаарна уу.
              </div>
            </div>
            <div class="fa-checkBoxTitle">Хоолой сонгох</div>
            <v-radio-group v-model="voiceId" hide-details>
              <div class="fa-checkboxWrapper" v-for="(n, index) in voice" :key="index">
                <v-radio class="fa-checkboxLabel" color="#787ff7" :label="`${n.people}`" :value="n.value"></v-radio>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="fa-playButton" @click="testVoice(n.value)" v-on="on" v-bind="attrs">
                      <PlayButtonIcon />
                    </div>
                  </template>
                  <span>Тоглуулах</span>
                </v-tooltip>
              </div>
            </v-radio-group>
            <div class="fa-soundSpeed">Тоглуулах хурд сонгох</div>
            <div class="fa-speedSelectWrapper">
              <v-select offset-y :items="voiceSpeed" v-model="speed" item-text="title" item-value="value"
                item-color="gray" hide-details dense outlined></v-select>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="fa-playSpeedButton" @click="testVoice(3)" v-on="on" v-bind="attrs">
                    <PlayButtonIcon />
                  </div>
                </template>
                <span>Тоглуулах</span>
              </v-tooltip>
            </div>
          </div>
          <div class="fa-dialogConfigActionWrapper">
            <v-btn class="fa-cancelBtn" style="margin-top: 0" @click="showConfigDialog"
              :disabled="allSynthLoading == true">
              Болих
            </v-btn>
            <v-btn class="fa-synthesizeButton" style="margin-top: 0; margin-right: 0" :loading="allSynthLoading"
              @click="synthesizeAllPage">
              <div style="margin-right: 10px">
                <MicWhiteIcon />
              </div>
              Яриа руу хувиргах
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="videoInsDialog" persistent max-width="800">
      <v-card class="fa-videoDialogWrapper">
        <!-- <video width="100%" controls>
          <source crossOrigin="anonymous" :src="video" type="video/mp4" />
          <source crossOrigin="anonymous" :src="video" type="video/ogg" />
          Your browser does not support HTML video.
        </video> -->
        <iframe width="100%" height="400px" src="https://www.youtube.com/embed/LY0lLcz3Qis" title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
        <div class="fa-dialogActionWrapper">
          <v-btn class="fa-closeBtn" text @click="videoInsDialog = false">хаах</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { format } from "date-fns";
import AudioPlayer from "../components/AudioPlayer";
import SettingsIcon from "../components/icons/SettingsIcon";
import QuizOutlineIcon from "../components/icons/QuizOutlineIcon";
import FixIcon from "../components/icons/FixIcon";
import DownloadIcon from "../components/icons/DownloadIcon";
import DeleteIcon from "../components/icons/DeleteIcon";
import MicWhiteIcon from "../components/icons/MicWhiteIcon";
import PlayButtonIcon from "../components/icons/PlayButtonIcon";
import ArrowLeftIcon from "../components/icons/ArrowLeftIcon";
import ArrowDownIcon from "../components/icons/ArrowDownIcon";
import FileSimpleIcon from "../components/icons/FileSimpleIcon";
import InfoIcon from "../components/icons/InfoIcon";
import PlayFillIcon from "../components/icons/PlayFillIcon";
import PauseOutlineIcon from "../components/icons/PauseOutlineIcon";
import { mapActions, mapState } from "vuex";
export default {
  name: "FileSynthAndDetails",
  components: {
    AudioPlayer,
    SettingsIcon,
    QuizOutlineIcon,
    FixIcon,
    DownloadIcon,
    MicWhiteIcon,
    PlayButtonIcon,
    DeleteIcon,
    ArrowLeftIcon,
    FileSimpleIcon,
    InfoIcon,
    PlayFillIcon,
    PauseOutlineIcon,
    ArrowDownIcon,
  },
  props: {
    fileInfo: {
      fileId: Number,
      fileName: String,
      index: String,
      status: String,
      synthesized: Number,
      total: Number,
      pagesInfo: Array,
      defaultPageInfo: Object,
    },
    deleteFile: { type: Function },
    getFileInfo: { type: Function },
  },
  data: () => ({
    hostURl: process.env.VUE_APP_BASE_URL,
    infoLoading: false,
    removeLoading: false,
    videoInsDialog: false,
    voiceId: "FEMALE3v2",
    background: "none",
    speed: 1,
    pitch: 1,
    voice: [
      { people: "Эрэгтэй хоолой", value: 2 },
      { people: "Эмэгтэй хоолой", value: 1 },
    ],
    voiceSpeed: [
      {
        value: 0.5,
        title: "0.5x - Удаан",
        audios: {
          1: "https://reader.chimege.com:/api/audio/3/61623163636430302d303430322d343030342d613332632d303338346237353666336232.wav",
          2: "https://reader.chimege.com:/api/audio/3/39383564326332662d313633332d343330392d613133652d643336336339326434393262.wav",
        },
      },
      {
        value: 0.75,
        title: "0.75x - Удаавтар",
        audios: {
          1: "https://reader.chimege.com:/api/audio/3/30333134306561662d373334342d346165382d613438622d666565366139656632326361.wav",
          2: "https://reader.chimege.com:/api/audio/3/39346335323832662d356462392d343736352d623663372d656332643864646330643037.wav",
        },
      },
      {
        value: 1,
        title: "Хэвийн",
        audios: {
          1: "https://reader.chimege.com:/api/audio/3/61396635616262342d346230302d343938662d396463362d333130393538306561356139.wav",
          2: "https://reader.chimege.com:/api/audio/3/34393961306532302d383339322d346335302d386466362d646239343839623265343063.wav",
        },
      },
      {
        value: 1.25,
        title: "1.25x - Хурдавтар",
        audios: {
          1: "https://reader.chimege.com:/api/audio/3/63316164373265362d316235632d346338642d626531362d376334373439346462376461.wav",
          2: "https://reader.chimege.com:/api/audio/3/31653635303835662d306138332d343561362d393638642d326537663366626164656537.wav",
        },
      },
      {
        value: 1.5,
        title: "1.5x - Хурдан",
        audios: {
          1: "https://reader.chimege.com:/api/audio/3/35393837636262652d383234382d343462322d386363362d333666376562646261313037.wav",
          2: "https://reader.chimege.com:/api/audio/3/61623636663438332d353336612d343663332d613237642d323262316461303062376337.wav",
        },
      },
      {
        value: 1.75,
        title: "1.75x - Маш хурдан",
        audios: {
          1: "https://reader.chimege.com:/api/audio/3/38666361663339612d353439372d346339632d383930662d303836323231366463626361.wav",
          2: "https://reader.chimege.com:/api/audio/3/61343062356532652d646264662d343661612d383661382d653264353761313635623235.wav",
        },
      },
    ],
    loading: false,
    allSynthLoading: false,
    dialogLoading: false,
    removeDialog: false,
    configDialog: false,
    page: 1,
    pageText: "",
    pageInfo: null,
    pages: null,
    readOnly: true,
    interval: null,
    firstText: "",
    file: {
      status: "",
      synthesized: 0,
      total: 0,
    },
    currentPlayingAudioIndex: null,
    jump_page: null,
    content: ["paragraph 1", "paragraph 2", "paragraph 3"],
  }),
  computed: {
    ...mapState(["allPlay", "currentAudioId", "clientKey", "audioInfo"]),
    filename: function () {
      let tmp = this.pageInfo.audio_path;
      let parts = tmp.split("/");
      return (
        parts.slice(0, parts.length - 1).join("/") +
        "/" +
        this.pageInfo.name.replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, "") +
        "-" +
        parts[parts.length - 1]
      );
    },
    getToken: function () {
      return this.$cookie.get("token");
    },
    getFormatDate: function () {
      var currentDate = new Date(this.pageInfo.synthesized_date);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
    getSpeedIns() {
      switch (this.pageInfo.speed.toString()) {
        case "0.5":
          return "0.5x - Удаан";
        case "0.75":
          return "0.75x - Удаавтар";
        case "1":
          return "Хэвийн";
        case "1.25":
          return "1.25x - Хурдавтар";
        case "1.5":
          return "1.5x - Хурдан";
        case "1.75":
          return "Маш хурдан";
        default:
          return "Тодорхойлох боломжгүй";
      }
    },
    autoPlay: function () {
      if (this.allPlay) {
        if (this.currentAudioId === this.pageInfo.id) {
          return true;
        } else {
          this.stopAllPlay();
          return false;
        }
      }
      return false;
    },
  },
  created() {
    if (this.fileInfo.pagesInfo != null) {
      this.pages = this.fileInfo.pagesInfo;
      this.pageInfo = this.fileInfo.defaultPageInfo;
    }
  },
  watch: {
    // "pageInfo.id": function() {
    //   if (
    //     this.pageInfo.status_new == "synthesizing" &&
    //     this.clientKey != null
    //   ) {
    //     this.addSubscribePage();
    //   }
    // },
    audioInfo: function () {
      if (this.audioInfo.oldProjectId === this.pageInfo.id) {
        this.pageInfo.percent = this.audioInfo.percent;
        this.pageInfo.status_new = this.audioInfo.projectStatus;
        if (this.pageInfo.status_new === "synthesized") {
          this.movePage();
        }
      }
    },
    currentAudioId: function () {
      if (this.currentAudioId === null) {
        this.currentPlayingAudioIndex = null;
      }
    },
  },
  destroyed() {
    // this.closeKey();
    this.stopAllPlay();
  },
  methods: {
    ...mapActions([
      "playAllPlay",
      "pauseAllPlay",
      "stopAllPlay",
      "pause",
      "changeCurrentId",
      "showWarningMessage",
      "showSuccessMessage",
      "showErrorMessage",
      "checkError",
      "updateBalance",
    ]),
    playAllAudios() {
      if (this.allPlay) {
        this.pauseAllPlay();
        this.pause();
      } else {
        this.playAllPlay();
        if (this.currentAudioId === null) {
          this.nextAudio();
        }
      }
    },

    nextAudio() {
      if (this.currentPlayingAudioIndex === null) {
        this.currentPlayingAudioIndex = 1;
      } else {
        this.currentPlayingAudioIndex += 1;
        if (this.currentPlayingAudioIndex > this.pages.length) {
          this.stopAllPlay();
          this.currentPlayingAudioIndex = null;
          return;
        }
      }
      this.page = this.currentPlayingAudioIndex;
      this.nextPage(this.page);
    },

    movePage() {
      this.nextPage(this.page);
    },

    // addSubscribePage() {
    //   let params = new percentRequest();
    //   params.setClientKey(this.clientKey);
    //   params.setProjectId(this.pageInfo.id);
    //   this.client.subscribePercent(
    //     params,
    //     {
    //       token: this.getToken,
    //     },
    //     (err) => {
    //       if (err) {
    //         console.log(err);
    //       }
    //     }
    //   );
    // },

    onEnd() {
      if (this.allPlay) {
        this.nextAudio();
      }
    },
    /**Тухайн хуудасны мэдээлийг харуулах функц */
    nextPage(page) {
      if (
        this.page != this.currentPlayingAudioIndex &&
        this.currentPlayingAudioIndex != null
      ) {
        this.stopAllPlay();
        this.currentPlayingAudioIndex = null;
      }
      this.infoLoading = true;
      this.readOnly = true;
      const headers = {
        token: this.getToken,
      };
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/v2/project/${this.pages[page - 1].id
          }`,
          {
            headers,
          }
        )
        .then((response) => {
          this.pageInfo = response.data.data;
          if (this.currentPlayingAudioIndex != null) {
            this.changeCurrentId(response.data.data.id);
          }
          this.infoLoading = false;
        })
        .catch((error) => {
          this.checkError(error);
        });
    },

    /**Оролт руу өгсөн хуудасруу шилжих функц */
    jumpPage() {
      var movePage = parseInt(this.jump_page, 10);
      if (this.synth_state.total >= movePage && movePage != this.page) {
        this.page = movePage;
        this.nextPage(this.page);
      } else if (this.synth_state.total < movePage) {
        this.showWarningMessage({
          message: "Тухайн файлын хуудсын тооноос хэтэрсэн байна.",
          timeout: 3000,
        });
      } else if (this.page == movePage) {
        this.showWarningMessage({
          message: "Тухайн хуудас дээр байна.",
          timeout: 3000,
        });
      } else {
        this.showWarningMessage({
          message: "Очих хуудасныхаа тоог оруулна уу.",
          timeout: 3000,
        });
      }
    },

    /**Тухайн хуудсыг хөрвүүлэх үед дуудагдах функц үед дуудагдах функц */
    synthesizePage() {
      if (this.pageInfo != null) {
        // this.addSubscribePage();
        this.loading = true;
        var headers = {
          token: this.getToken,
        };
        axios
          .post(
            `${process.env.VUE_APP_BASE_URL}/v2/project/${this.pageInfo.id}/synthesize?voiceID=${this.voiceId}&speed=${this.speed}&backgound=${this.background}&pitch=${this.pitch}`,
            {},
            { headers }
          )
          .then((res) => {
            if (res.status == 200) {
              this.pageInfo = res.data.data;
              this.updateBalance(this.getToken);

              // this.addSubscribeFile(this.fileInfo.fileId);
              this.loading = false;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.checkError(error);
          });
      } else {
        this.showWarningMessage({
          message: "Засварласан бичвэрээ хадгална уу!",
          timeout: 3000,
        });
      }
    },
    /**Бичвэрт засвар оруулан дахин хөрвүүлэх үед дуудагдах функц функц */
    againSynthesizePage() {
      var headers = {
        token: this.getToken,
        voiceID: this.voiceId,
        speed: this.speed,
        pitch: this.pitch,
        background: this.background
      };
      this.loading = true;
      axios
        .put(
          `${process.env.VUE_APP_BASE_URL}/v2/project/${this.pageInfo.id}`,
          {
            id: this.pageInfo.id,
            text: this.pageInfo.text,
            voice_id: this.pageInfo.voice_id,
            speed: this.pageInfo.speed,
            pitch: this.pageInfo.pitch,
            background: this.pageInfo.background,
          },
          { headers }
        )
        .then((res) => {
          if (res.status == 200) {
            this.synthesizePage();
          }
        })
        .catch((error) => {
          this.checkError(error);
        });
    },

    /**Бүх хуудсыг хөрвүүлэх функц */
    synthesizeAllPage() {
      this.allSynthLoading = true;
      var headers = {
        token: this.getToken,
      };
      axios
        .post(
          `${process.env.VUE_APP_BASE_URL}/v2/group/${this.fileInfo.fileId}/synthesize?voiceID=${this.voiceId}&speed=${this.speed}`,
          {},
          { headers }
        )
        .then((res) => {
          if (res.status == 200) {
            this.allSynthLoading = false;
            this.configDialog = false;
            // this.addSubscribeFile(this.fileInfo.fileId);
            this.pageInfo.status_new = "synthesizing";
            this.pageInfo.voice_id = this.voiceId;
            this.pageInfo.speed = this.speed;
            this.pageInfo.background = this.background;
            this.pageInfo.pitch = this.pitch;
            this.updateBalance(this.getToken);
          }
        })
        .catch((error) => {
          this.allSynthLoading = false;
          this.checkError(error);
        });
    },
    /**Бүх хуудсыг хөрвүүлэхийн тулд гарч ирэх диалог  */
    showConfigDialog() {
      this.configDialog = !this.configDialog;
      this.voiceId = 2;
      this.speed = 1;
    },

    /** Тухайн хуудасны бичвэрийг засах болон хаах эрхийг өгөх функц */
    editText() {
      if (this.readOnly == true) {
        this.readOnly = false;
        this.firstText = this.pageInfo.text;
        this.$refs.textInput.focus();
      } else {
        this.readOnly = true;
        this.pageInfo.text = this.firstText;
      }
    },
    /**Тухайн хуудсыг устгах  */
    removePage() {
      this.dialogLoading = true;
      var headers = {
        token: this.getToken,
      };
      if (this.pages.length == 1) {
        this.deleteFile(this.fileInfo.fileId);
      } else {
        axios
          .delete(
            `${process.env.VUE_APP_BASE_URL}/deleteproject/${this.pageInfo.id}`,
            {},
            { headers }
          )
          .then((res) => {
            if (res.status == 200) {
              this.dialogLoading = false;
              this.removeDialog = false;
              this.showSuccessMessage({
                message: "Хуудас устгагдлаа",
                timeout: 3000,
              });
              this.getFileInfo(this.fileInfo.fileId);
            }
          })
          .catch((error) => {
            this.removeDialog = false;
            this.checkError(error);
          });
      }
    },
    /**Тухайн хуудсыг устгах үед гарах функц */
    toggleDialog() {
      this.removeDialog = !this.removeDialog;
    },
    /**Жишээ яриаг ялгаж явуулах функц */
    async testVoice() {
      var response = await synthesize(this.voiceID, this.speed, this.pitch);
      const url = window.URL.createObjectURL(response);
      var audio = new Audio(url);
      audio.play()
    }
  },

  watchVideo() {
    this.videoInsDialog = true;
  },
  onInput(event, index) {
    const value = event.target.innerText;
    this.content[index] = value;
    if (value == "") {
      document.getElementById(`content-${index}`).remove();
    }

    // const value = event.target.innerText;
    // this.content[index].value = value;
  },
}
async function synthesize(voiceID, speed, pitch) {
  let resp = await axios('/api/demoPlay', {
    method: 'POST',
    responseType: 'blob',
    headers: {
      "voice-id": voiceID,
      "speed": speed,
      "pitch": pitch,
    },
  })

  return resp
}
</script>
<style scoped>
.fa-fileFullWrapper {
  display: flex;
  flex-direction: column;
}

.fa-fileInfoWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  background-color: #ffffff;
  margin-bottom: 20px;
  min-height: 66px;
  flex-wrap: wrap;
}

.fa-fileNameWrapper {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #767676;
}

.fa-fileName {
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
  color: #231f20;
  margin: 0 4px;
}

.fa-pageInfoWrapper {
  display: flex;
}

.fa-synthesizeButton,
.fa-allPlayButton {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
  text-indent: 0;
  margin-right: 10px;
  margin: 2px 0;
}

.fa-pageRemoveBtn {
  background-color: #ffffff !important;
  color: #767676;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  box-shadow: none;
  outline: none;
  height: 40px !important;
  min-width: 40px !important;
  padding: 0 !important;
  margin-top: 10px;
}

.fa-subTitle {
  font-size: 14px;
  font-weight: 700;
  color: #767676;
  margin-bottom: 10px;
}

.fa-fileInfoWrapper {
  display: flex;
}

.fa-textShowWrapper {
  display: flex;
  flex-direction: column;
  width: 60%;
}

.fa-textInput {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 16px;
  height: 352px;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  overflow-y: scroll;
  resize: none;
}

.fa-editable {
  outline: none;
  height: max-content;
  /* max-width:100%; */
  margin-bottom: 0 !important;
  margin-right: 5px;
}

.fa-editable:focus {
  background-color: #e5e5e5;
}

.fa-editable:hover {
  background-color: #e5e5e5;
}

.fa-inputBorder {
  border: 1px solid #777ff6;
}

.fa-paginationWrapper {
  display: flex;
  align-items: center;
  width: 60%;
  height: 50px;
  justify-content: space-between;
  margin-top: 10px;
}

.fa-jumpPageWrapper {
  display: flex;
  align-items: center;
}

.fa-jumpPageTitle {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #98a7ad;
  margin-right: 8px;
}

.fa-inputNumber {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 30px;
  width: 50px;
}

.fa-inputNumber input[type="number"] {
  height: 30px !important;
  padding-left: 4px;
  padding-right: 4px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  line-height: 16px;
  transition: 0.4s ease-out;
}

.fa-inputNumber input[type="number"]:focus {
  border: 1px solid #777ff6 !important;
  outline: none;
}

.fa-inputNumber input[type="number"]:hover {
  border: 1px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}

.fa-jumpBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 30px !important;
  letter-spacing: 0;
  text-indent: 0;
  padding-left: 2px !important;
  padding-right: 0 !important;
  margin-left: 10px;
}

.fa-jumpBtn:hover {
  background-color: white !important;
}

.fa-pageWrapper {
  width: 100%;
  height: 113px;
  margin-top: 10px;
  overflow-x: auto;
}

.fa-textInput::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
}

.fa-textInput::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.fa-settingsWrapper {
  width: calc(40% - 40px);
  margin-left: 40px;
}

.fa-settingsTitleWrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;
}

.fa-settingsTitle,
.fa-videoIns {
  display: flex;
  color: #98a7ad;
  font-size: 14px;
  font-weight: 500;
  height: 21px;
  align-items: center;
}

.fa-videoIns {
  font-weight: 400;
  height: 16px;
  cursor: pointer;
}

.fa-videoIns:hover {
  text-decoration: underline;
}

.fa-toolsWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: 270px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  justify-content: space-between;
}

.fa-dialogConfigWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
}

.fa-dialogConfigActionWrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  flex-wrap: wrap;
}

.fa-dialogConfigWarnWrapper {
  display: flex;
  align-items: center;
  background-color: #f6ffed;
  border: 1px solid #e6f5d7;
  border-radius: 6px;
  padding: 15px;
  margin: 12px 0 24px 0;
}

.fa-dialogConfigWarn {
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin-left: 15px;
}

.fa-synthesizedWrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.fa-thingsBtnWrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

.fa-checkBoxTitle,
.fa-soundSpeed {
  font-weight: 500;
  font-size: 14px;
  color: #231f20;
  margin-bottom: 8px;
}

.fa-soundSpeed {
  margin-top: 16px;
}

.fa-speedSelectWrapper {
  width: 242px;
  display: flex;
}

.fa-checkboxesWrapper {
  display: flex;
  flex-direction: column;
}

.fa-checkboxWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.fa-playButton {
  display: flex;
  height: 16px;
  margin-left: 10px;
  cursor: pointer;
}

.fa-playSpeedButton {
  margin-left: 10px;
  height: 16px;
  margin-top: 12px;
  cursor: pointer;
}

.v-input {
  margin: 0;
}

.v-radio {
  margin: 0 !important;
}

.v-label {
  font-size: 14px !important;
  color: #000000 !important;
}

.v-pagination--item {
  font-size: 12px !important;
}

.fa-audioTitleStyle {
  font-size: 14px;
  font-weight: 500;
  color: #231f20;
  line-height: 16px;
}

.fa-fileInfoStyle {
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  line-height: 24px;
}

.fa-transcribingShow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  background-color: #7c7faf;
  color: #f7f7f7;
  font-weight: 700;
  line-height: 16px;
  font-size: 14px;
  border-radius: 6px;
}

.fa-infoLoadingWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 383px;
  height: auto;
}

.fa-thingsWrapper {
  display: flex;
  width: calc(40% - 40px);
  flex-wrap: wrap;
  margin-top: 10px;
  margin-left: 40px;
}

.fa-thingsBtn,
.fa-cancelBtn {
  background-color: #ffffff !important;
  border: 1px solid #e5e5e5;
  text-transform: initial;
  color: #767676;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
  text-indent: 0;
  margin-right: 10px;
  margin-top: 10px;
}

.fa-againSynthBtn {
  background-color: #ffffff !important;
  border: 1px solid #e5e5e5;
  text-transform: initial;
  color: #767676;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
  text-indent: 0;
  width: 200px;
  margin-right: 10px;
  margin-top: 10px;
}

.fa-toolsBtnWrapper {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
}

.fa-fixBtn {
  background-color: #ffffff !important;
  border: 1px solid #e5e5e5;
  text-transform: initial;
  color: #767676;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 40px !important;
  letter-spacing: 0;
  text-indent: 0;
  margin-bottom: 10px;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}

/* Диалог хэлбэржүүлэлтүүд */
.fa-dialogWrapper {
  padding: 31px 38px;
}

.fa-dialogRemoveTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  color: #d23636;
}

.fa-dialogRemoveTitle {
  font-size: 16px;
  font-weight: 500;
  color: #d23636;
  margin-left: 10px;
  line-height: 18px;
}

.fa-dialogRemoveQuestion {
  font-size: 14px;
  line-height: 16px;
  color: #767676;
}

.fa-removeBtn {
  background-color: #d23636 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.fa-dialogActionWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.fa-closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 15px;
  height: 34px !important;
  width: 64px !important;
}

.v-menu__content {
  border: 1px solid #e5e5e5 !important;
  background-color: #ffffff;
  border-radius: 6px !important;
  box-shadow: none !important;
  padding-top: 0 !important;
  box-shadow: 0px 9px 16px rgba(0, 0, 0, 0.06) !important;
}

.v-list {
  padding: 0;
}

.v-list-item__content {
  padding: 0;
}

.fa-listItem {
  border-bottom: 1px solid #e5e5e5;
}

.fa-listTitle {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #231f20;
  margin-bottom: 4px;
}

.fa-listDesc {
  font-size: 12px;
  line-height: 14px;
  color: #767676;
}

.fa-videoDialogWrapper {
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
}

.fa-fileActionsWrapper {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 930px) {
  .fa-pageInfoWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .fa-bottomWrapper {
    flex-direction: column-reverse;
  }

  .fa-textShowWrapper,
  .fa-paginationWrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .fa-settingsWrapper,
  .fa-thingsWrapper {
    width: 100%;
    margin: 10px 0 0 0;
    height: auto;
  }

  .fa-toolsWrapper {
    height: auto;
  }
}

@media screen and (max-width: 599px) {
  .fa-dialogWrapper {
    padding: 20px;
  }

  .fa-fileName {
    max-width: 121px;
  }
}
</style>
